import { Injectable } from '@angular/core';
import { DispatchedServiceViewModel } from 'src/app/driver/models/view-models/dispatched-service.view-model';
import { OrderedServicesService } from '../core/ordered-services.service';
import { map, Observable } from 'rxjs';

/**
 * Query class for getting accepted dispatched services that have not been performed.
 */
@Injectable({
	providedIn: 'root'
})
export class AcceptedAndNotPerformedServicesQueryService {
	/**
	 * @constructor
	 *
	 * @param orderedServicesService The service used to get ordered services hydrated with state data.
	 */
	constructor(
		private readonly orderedServicesService: OrderedServicesService
	) { }

	/**
	 * Gets the list of accepted dispatched services that have not been performed in order.
	 * @returns The list of accepted dispatched services that have not been performed in order.
	 */
	public GetAcceptedAndNotPerformedServices$(): Observable<DispatchedServiceViewModel[]> {
		return this.orderedServicesService.GetOrderedServices$().pipe(
			map((services: DispatchedServiceViewModel[]) => services.filter((service: DispatchedServiceViewModel) => service.IsAcceptedAndNotPerformed))
		);
	}
}
